import React from 'react';
import Ninja from '@ninja';
import FormatterButton from 'components/table-formatters/components/FormatterButton';
import { mdiOpenInNew, mdiContentCopy } from '@mdi/js';
import TableIcons from 'components/table-formatters/TableIcons/TableIcons';
import { NameFormatter, StatusFormatter } from 'components/tables/NinjaTable/formatters';
import copyToClipboard from 'common/utils/copyToClipboard';
import { NetworkFormatter } from 'components/tables/NinjaTable/formatters';

const UrlFormatter = ({ row, showNetwork = true }) => {
  if (!row || !row.url) {
    return '-';
  }

  const { url } = row;

  const handleUrl = () => {
    if (url?.url) {
      window.open(url.url, '_blank', 'noopener,noreferrer');
    }
  };

  const copyName = (e) => {
    e.stopPropagation();

    copyToClipboard(url.name);
  };

  const icons = [
    {
      icon: mdiContentCopy,
      onClick: copyName,
      tooltip: 'Copy Name',
      onlyOnHover: true,
      show: url?.name,
    },
    { icon: mdiOpenInNew, onClick: handleUrl, tooltip: 'Url', show: url?.url ? true : false },
  ];

  return (
    <FormatterButton className='icons-hover-trigger !bg-error-light'>
      <NetworkFormatter row={{ network: 'custom_urls' }} title='Custom URLS' />
      <div className='flex gap-2 items-center w-full relative'>
        {showNetwork && <NetworkFormatter row={url} />}
        <StatusFormatter row={url} />
        <NameFormatter name={url.name} />
        <TableIcons color={Ninja.colors.light} icons={icons} />
      </div>
    </FormatterButton>
  );
};

export default UrlFormatter;
